/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

define(__m[209/*vs/base/common/marked/marked*/], __M([552/*vs/base/common/marked/raw.marked*/]), function (marked) {
	return {
		marked: marked
	};
});